export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4734.80e27b34.jpg";